import { trackError } from '@if/core/telemetry'
import { isNetworkError } from '@if/core/utils'

export function reportErrorToConsole(error: unknown) {
  console.error(error)
}

export function reportErrorToServer(error: Error) {
  if (!isNetworkError(error)) {
    reportErrorToConsole(error)
    trackError(error)
  }
}
